import { usePageData } from '@/contexts/pageContext';
import { useDataLayer } from '@/hooks/useDataLayer';
import { toGa4Item } from '@/utils/toGa4Item';
import { getAuthUserToken } from '@/utils/searchAnalytics';
import { useEffect, useRef } from 'react';

export const useViewItem = () => {
  const { product } = usePageData();
  const { viewItem, push } = useDataLayer();
  const firedRef = useRef(false);

  useEffect(() => {
    if (!product?.sku || firedRef.current) {
      return;
    }
    firedRef.current = true;
    viewItem(toGa4Item(product));

    // Algolia insight: "Product Detail Page Viewed"
    // Migrated from _AlgoliaInsightEvents.cshtml Model.IsProductPage block
    push({
      event: 'Product Detail Page Viewed',
      authUserToken: getAuthUserToken(),
      objectIds: product.sku,
    });
  }, [product, viewItem, push]);
};
